import React from 'react'
import styled from '@emotion/styled'

import { breakpoints } from '../../utils/styles'

const Heading = props => {
  const { children } = props
  return <Text {...props}>{children}</Text>
}

export default Heading

export const Text = styled.div`
  font-family: 'Recoleta';
  font-weight: 400;
  font-size: ${props => (props.fontSize ? props.fontSize : ' 64px')};
  line-height: 1.2;

  span {
    font-family: 'SohneBreit';
    font-weight: 700;
    font-size: 99%;

    a {
      text-decoration: underline;
      color: currentColor;
    }
  }

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${props =>
      props.mobileFontSize ? props.mobileFontSize : ' 38px'};
  }
`
